module.exports = __webpack_public_path__ + "static/floorplan_01-320d58ec9a169e987d964a1a8bdc15ce.jpg";